import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import {
  ContainerItemModel,
  ContainerItemOption,
  ContainerModel,
} from '@app/models/server/layout.model';
import { SelectedItem } from '@app/models/client/item.model';
import { EventService } from '@app/services/util-services/root-services/event-service';
import { Subscription } from 'rxjs';
import { AnalyticsEventService } from '@app/services/util-services/root-services/analytics-event-service';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-b2b-filter-buttons',
  templateUrl: './b2b-filter-buttons.component.html',
  styleUrls: ['./b2b-filter-buttons.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [FormsModule],
})
export class B2bFilterButtonsComponent implements OnInit, OnDestroy {
  @Input() compData: {
    container: ContainerModel;
  };

  initialValue: SelectedItem;
  clearAllFilterEventSubscription$: Subscription;

  selectedOption: ContainerItemOption;

  @Output() selectEvent: EventEmitter<any> = new EventEmitter<any>();

  constructor(
    private eventService: EventService,
    private analyticsEventService: AnalyticsEventService,
  ) {}

  ngOnInit() {
    this.clearAllFilterEventSubscription$ =
      this.eventService.clearAllFilterEvent.subscribe({
        next: (result: any) => {
          this.initialValue = undefined;
        },
      });
    this.setInitialValues();
  }

  setInitialValues() {
    if (this.compData?.container?.data?.length > 0) {
      for (const containerItem of this.compData?.container?.data) {
        const foundedOption: ContainerItemOption = containerItem?.options?.find(
          (item: ContainerItemOption) => {
            return item.selected;
          },
        );
        if (foundedOption) {
          this.initialValue = {
            title: foundedOption.title,
            description: foundedOption.description,
            value: foundedOption,
            fieldConfig: {
              uid: containerItem?.uid,
              name: containerItem?.name,
            },
          };
          this.selectedOption = foundedOption;
        }
      }
    }
  }

  onChange(option: ContainerItemOption, containerItem: ContainerItemModel) {
    // LoggerService.log('option ', option, 'item ', containerItem);
    this.analyticsEventService.fireAnalyticsEvent.emit({
      eventName: option?.type?.toLowerCase(),
      data: option?.title,
    });

    this.initialValue = {
      title: option.title,
      description: option.description,
      value: option,
      fieldConfig: {
        uid: containerItem?.uid,
        name: containerItem?.name,
      },
    };

    // LoggerService.log('this.initialValue : ', this.initialValue);
    this.eventService.filterChangeEvent.emit({
      filterValues: { [containerItem?.uid]: this.initialValue },
    });
    // this.selectEvent.emit(this.initialValue);
  }

  onContainerOptionSelect(
    option: ContainerItemOption,
    containerItem: ContainerItemModel,
  ) {
    if (option) {
      this.onChange(option, containerItem);
    }
  }

  ngOnDestroy(): void {
    if (this.clearAllFilterEventSubscription$) {
      this.clearAllFilterEventSubscription$.unsubscribe();
    }
  }

  ionViewDidLeave() {
    if (this.clearAllFilterEventSubscription$) {
      this.clearAllFilterEventSubscription$.unsubscribe();
    }
  }
}
